import React from "react";

const StoicStrip = () => (
  <div className="stoic-strip" style={s.strip}>
    <blockquote style={s.quote}>
      "Waste no more time arguing what a good man should be. Be one."
      <cite style={s.cite}>— Marcus Aurelius, Meditations</cite>
    </blockquote>
  </div>
);

const s = {
  strip: {
    background: "var(--bg2)",
    borderTop: "1px solid var(--border)",
    borderBottom: "1px solid var(--border)",
    padding: "2rem 3rem",
    textAlign: "center",
  },
  quote: {
    fontFamily: "var(--serif)",
    fontStyle: "italic",
    fontSize: "clamp(0.95rem, 1.8vw, 1.1rem)",
    color: "var(--muted2)",
    maxWidth: 600,
    margin: "0 auto",
    lineHeight: 1.9,
  },
  cite: {
    display: "block",
    fontFamily: "var(--mono)",
    fontStyle: "normal",
    fontSize: "0.65rem",
    color: "var(--muted)",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginTop: "0.75rem",
  },
};

export default StoicStrip;
